export default customerId => ({
  name: "",
  description: "",
  customerId,
  layouts: [],
  schedules: [
    {
      type: "banner",
      period: 900,
    },
  ],
});
